import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { useTranslation } from 'react-i18next';

import { BaseText, Icon, Separator } from '@components';
import { Course } from '@models/Courses/CourseModel';

const Title = styled(BaseText)({
  variant: 'text.xxlarge',
  color: '$heading800',
  fontWeight: 'semi',
  marginBottom: '$6',
});

const DetailRow = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const LeftContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const DetailLabel = styled(BaseText)({
  variant: 'text.small',
  color: '$heading800',
  marginLeft: '$4',
  fontWeight: 'semi',
});

const DetailValue = styled(BaseText)({
  variant: 'text.small',
  color: '$text200',
});

interface ICourseDetailsProps {
  course: Course;
}

export const CourseDetails = ({ course }: ICourseDetailsProps) => {
  const { t } = useTranslation();

  return (
    <View>
      <Title>{t('courseSummary.detailsTitle')}</Title>

      <DetailRow>
        <LeftContainer>
          <Icon name="chart-bold" size={16} color="$primary300" />
          <DetailLabel>{t('courseSummary.skillLevel')}</DetailLabel>
        </LeftContainer>
        <DetailValue>{course.skillLevel}</DetailValue>
      </DetailRow>
      <Separator size="$4" />
      <DetailRow>
        <LeftContainer>
          <Icon
            name="time-circle-bold"
            size={16}
            color="$primary300"
          />
          <DetailLabel>{t('courseSummary.duration')}</DetailLabel>
        </LeftContainer>
        <DetailValue>
          {t('courseSummary.stagesCount', {
            count: course.durationCourse.lessonsCount,
          })}
          ,{' '}
          {t('courseSummary.videosCount', {
            count: course.durationCourse.videosCount,
          })}
        </DetailValue>
      </DetailRow>
      <Separator size="$4" />
      <DetailRow>
        <LeftContainer>
          <Icon name="education-bold" size={16} color="$primary300" />
          <DetailLabel>{t('courseSummary.students')}</DetailLabel>
        </LeftContainer>
        <DetailValue>{course.studentsCount}</DetailValue>
      </DetailRow>
    </View>
  );
};
